var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Container"},[_c('div',{staticClass:"Half First"}),_c('div',{staticClass:"Half Second"})])}]

export { render, staticRenderFns }